<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Measuring Types'}}</h4>
            </div>
        </div>

        <div class="white-box">
            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Type</h5>
                        <input type="text" class="form-control ms-input" placeholder=""
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-start">
            <button class="submmit-btn">Create</button>
        </div>

        <div class="white-box">
            <div class="row px-4">
                <div class="col-md-12 col-12">
                    <div class="grey-box">
                        <div class="column">
                            <h5 class="medium-h my-2">{{'Measuring Types' | translator}}</h5>
                            <input type="text" class="form-control ms-input-white" placeholder=""
                                id="exampleInputEmail1" aria-describedby="emailHelp">
                        </div>
                        <div class="my-5">
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                01
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name"></div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                02
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name"></div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                03
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name"></div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>